module.exports = __webpack_public_path__ + "img/AK0092-PI.b6292d8b.jpg";